// Drafts: what someone has typed but not sent, kept per person, channel and
// thread in this browser so it survives moving around and reloading. They
// are dropped on sign-out, since they are in the clear on this device.

const prefix = "lantern.draft.";

export function draftKey(me: string, channel: string, thread?: string | null): string {
  return prefix + me + "." + channel + (thread ? "." + thread : "");
}

export function loadDraft(key: string): string {
  try {
    return localStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

export function saveDraft(key: string, text: string) {
  try {
    if (text.trim()) localStorage.setItem(key, text);
    else localStorage.removeItem(key);
  } catch {
    // Private windows may refuse; the draft lasts while the page is open.
  }
}

// draftedChannels is the channels where me has a draft (not in a thread).
export function draftedChannels(me: string): Set<string> {
  const out = new Set<string>();
  const mine = prefix + me + ".";
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(mine) && !k.slice(mine.length).includes(".")) out.add(k.slice(mine.length));
    }
  } catch {
    // Nothing kept.
  }
  return out;
}

// Draft is an unsent draft, where it is.
export interface Draft {
  key: string;
  channel: string;
  thread: string | null;
  text: string;
}

// allDrafts is me's drafts, in channels and threads alike.
export function allDrafts(me: string): Draft[] {
  const out: Draft[] = [];
  const mine = prefix + me + ".";
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k?.startsWith(mine)) continue;
      const [channel, thread] = k.slice(mine.length).split(".");
      const text = localStorage.getItem(k) ?? "";
      if (text.trim()) out.push({ key: k, channel, thread: thread ?? null, text });
    }
  } catch {
    // Nothing kept.
  }
  return out;
}

export function clearDrafts() {
  try {
    const keys: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(prefix)) keys.push(k);
    }
    keys.forEach((k) => localStorage.removeItem(k));
  } catch {
    // Nothing kept.
  }
}
